import { Scene } from '../../game/Scene'

type GameProps = {
    onSceneReady?: () => void
    onReturnToMenu?: () => void
    onReturnToConfigurator?: () => void
    renderEnabled?: boolean
}

export default function Game({
    onSceneReady,
    onReturnToMenu,
    onReturnToConfigurator,
    renderEnabled = true,
}: GameProps) {
    return (
        <Scene
            onSceneReady={onSceneReady}
            onReturnToMenu={onReturnToMenu}
            onReturnToConfigurator={onReturnToConfigurator}
            renderEnabled={renderEnabled}
        />
    )
}
